import { useEffect } from "react";
import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Differentials } from "@/components/site/Differentials";
import { Reviews } from "@/components/site/Reviews";
import { Location } from "@/components/site/Location";
import { Footer } from "@/components/site/Footer";
import { StickyWhatsapp } from "@/components/site/StickyWhatsapp";

function App() {
  useEffect(() => {
    // Instant, zero-lag anchor navigation with offset
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (!id || id.length < 2) return;
      
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        const headerOffset = 80;
        const elementPosition = el.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    };

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <div className="App min-h-screen bg-clinic-bg text-clinic-ink selection:bg-clinic-pink selection:text-clinic-ink">
      <Nav />
      <main id="main-content">
        <Hero />
        <Marquee />
        <About />
        <Differentials />
        <Reviews />
        <Location />
      </main>
      <Footer />
      <StickyWhatsapp />
    </div>
  );
}

export default App;


